module.exports = __webpack_public_path__ + "da2c3462e3ae207e3553be847e431e05.png";